// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Pin$Showside from "../types/Pin.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as CategoryCard$Showside from "./CategoryCard.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewProductsOverlay$Showside from "./QuickViewProductsOverlay.bs.js";
function QuickViewCard(Props) {
  var category = Props.category;
  var parentCategory = Props.parentCategory;
  var shape = Props.shape;
  var fluidOpt = Props.fluid;
  var roundedOpt = Props.rounded;
  var showTitleOpt = Props.showTitle;
  var showDescriptionOpt = Props.showDescription;
  var showTaggedProductsOpt = Props.showTaggedProducts;
  var enableViewProductButtonOpt = Props.enableViewProductButton;
  var imageFitToContainer = Props.imageFitToContainer;
  var style = Props.style;
  var onClick = Props.onClick;
  var onOverlayProductClick = Props.onOverlayProductClick;
  var onImageRendered = Props.onImageRendered;
  var fluid = fluidOpt !== undefined ? fluidOpt : false;
  var rounded = roundedOpt !== undefined ? roundedOpt : true;
  var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
  var showDescription = showDescriptionOpt !== undefined ? showDescriptionOpt : true;
  var showTaggedProducts = showTaggedProductsOpt !== undefined ? showTaggedProductsOpt : true;
  var enableViewProductButton = enableViewProductButtonOpt !== undefined ? enableViewProductButtonOpt : true;
  var productCategory = Belt_Option.getWithDefault(parentCategory, category);
  var enableViewProductButton$1 = enableViewProductButton && shape !== /* Circle */0;
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var settings = match$1.settings;
  var match$2 = EntrypointContext$Showside.use(undefined);
  var onOpenLink = match$2.onOpenLink;
  var match$3 = ViewportContext$Showside.use(undefined);
  var match$4 = RouterProvider$Showside.useRouter(undefined);
  var imageFitToContainer$1 = Belt_Option.getWithDefault(imageFitToContainer, settings.categoryCardFitToContainer);
  var showTaggedProducts$1 = !match$4.isQuickView && showTaggedProducts;
  var productIds = React.useMemo(function () {
    return Category$Showside.getProductIds(category);
  }, [category]);
  var match$5 = UseApi$Showside.useProductsById(match$1.transitiveStoreId, productIds, settings.hideOutOfStock, true, productCategory.id, match$2.smartnavApiHost, match$2.market, undefined);
  var products = Belt_Option.getWithDefault(match$5.products, []);
  var data = React.useMemo(function () {
    var data = category.categoryType;
    if (typeof data === "number") {
      return;
    }
    switch (data.TAG | 0) {
      case /* Standard */1:
        return data._0;
      case /* QuickView */2:
        var data$1 = data._0;
        return {
          firstCard: data$1.firstCard,
          externalConnection: data$1.externalConnection,
          children: data$1.children,
          loadMoreChildren: data$1.loadMoreChildren,
          totalChildren: data$1.totalChildren,
          link: data$1.link,
          products: data$1.products,
          taggedMedia: undefined,
          imageHotspots: data$1.imageHotspots,
          imageWidth: data$1.imageWidth,
          imageHeight: data$1.imageHeight
        };
      default:
        return;
    }
  }, [category.categoryType]);
  var onOverlayButtonClick = React.useCallback(function (param) {
    Belt_Option.forEach(onClick, function (onClick) {
      Curry._2(onClick, parentCategory, category);
    });
  }, [category]);
  var onOverlayProductClick$1 = React.useCallback(function (product) {
    return function (variant) {
      if (settings.openProductLink) {
        return Curry._5(onOpenLink, productCategory, undefined, product, variant, undefined);
      } else {
        return Belt_Option.forEach(onOverlayProductClick, function (fn) {
          Curry._4(fn, category, parentCategory, product, variant);
        });
      }
    };
  }, [category, settings.openProductLink, onOpenLink, onOverlayProductClick]);
  var match$6 = category.categoryType;
  var match$7 = Category$Showside.Link.getCardFallbackLink(category);
  var buttonKind;
  var exit = 0;
  if (typeof match$6 === "number" || match$6.TAG !== /* QuickView */2) {
    exit = 1;
  } else {
    var match$8 = match$6._0;
    if (match$8.isPinned) {
      buttonKind = /* Pin */6;
    } else if (match$8.children.length !== 0) {
      buttonKind = /* ViewAlbum */4;
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    buttonKind = products.length !== 0 ? /* ViewProducts */2 : match$7 !== undefined ? (/* LearnMore */{
      _0: match$7
    }) : /* ViewZoom */3;
  }
  var pins = React.useMemo(function () {
    return Belt_Option.getWithDefault(Belt_Option.map(data, function (data) {
      return Belt_Option.getWithDefault(Belt_Option.map(data.imageHotspots, function (pins) {
        return Belt_Array.keepMap(Belt_Array.map(pins, function (__x) {
          return Pin$Showside.fromDTO(__x, products);
        }), function (p) {
          return p;
        });
      }), Pin$Showside.fromTaggedProducts(data.products, products));
    }), []);
  }, [data, products]);
  var visibility = match$3.isMobile ? /* AlwaysShow */1 : /* AutoHide */0;
  var renderOverlay = React.useCallback(data !== undefined ? Belt_Option.isSome(data.imageHotspots) ? function (param) {
    var tmp = {
      size: /* Lg */1,
      dynamicTooltipWidth: true,
      productCardShape: settings.productCardShape,
      pins: pins,
      active: true,
      visibility: visibility,
      enableButton: enableViewProductButton$1,
      buttonKind: buttonKind,
      buttonMargin: "0 0 6px 8px",
      showPins: showTaggedProducts$1,
      displayVariantBy: displayVariantBy,
      imageFitToContainer: settings.productCardFitToContainer,
      openLinkInNewTab: settings.openLinkInNewTab,
      hideOutOfStock: settings.hideOutOfStock,
      onClickButton: onOverlayButtonClick,
      onClickPin: onOverlayProductClick$1
    };
    var tmp$1 = imageFitToContainer$1 ? "contain" : undefined;
    if (tmp$1 !== undefined) {
      tmp.fit = tmp$1;
    }
    if (data.imageWidth !== undefined) {
      tmp.width = data.imageWidth;
    }
    if (data.imageHeight !== undefined) {
      tmp.height = data.imageHeight;
    }
    return React.createElement(QuickViewProductsOverlay$Showside.Hotspots.make, tmp);
  } : function (param) {
    var tmp = {
      pins: pins,
      active: true,
      visibility: visibility,
      enableButton: enableViewProductButton$1,
      productCardShape: settings.productCardShape,
      buttonKind: buttonKind,
      buttonMargin: "0 0 6px 8px",
      showStack: showTaggedProducts$1,
      displayVariantBy: displayVariantBy,
      hideOutOfStock: settings.hideOutOfStock,
      imageFitToContainer: settings.productCardFitToContainer,
      openLinkInNewTab: settings.openLinkInNewTab,
      onClickButton: onOverlayButtonClick,
      onClickThumbnail: onOverlayProductClick$1
    };
    var tmp$1 = settings.productCardFitToContainer ? /* Contain */2 : undefined;
    if (tmp$1 !== undefined) {
      tmp.imageFit = Caml_option.valFromOption(tmp$1);
    }
    return React.createElement(QuickViewProductsOverlay$Showside.Stack.make, tmp);
  } : function (param) {
    return null;
  }, [data, pins, settings, buttonKind, enableViewProductButton$1, displayVariantBy, showTaggedProducts$1, onOverlayButtonClick, onOverlayProductClick$1]);
  var titleTextSize = shape === /* Circle */0 ? /* Base */2 : undefined;
  var onClickTemp = React.useCallback(function (category) {
    Belt_Option.forEach(onClick, function (onClick) {
      Curry._2(onClick, parentCategory, category);
    });
  }, [category]);
  var onClick$1 = onClick !== undefined ? onClickTemp : undefined;
  var tmp = {
    category: category,
    shape: shape,
    fluid: fluid,
    renderOverlay: renderOverlay,
    showVideoIndicator: true,
    showTitle: showTitle,
    rounded: rounded,
    showDescription: showDescription,
    videoControlsClassName: CSS$Showside.prefix("z-20"),
    imageFitToContainer: imageFitToContainer$1
  };
  if (titleTextSize !== undefined) {
    tmp.titleTextSize = Caml_option.valFromOption(titleTextSize);
  }
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  if (onClick$1 !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick$1);
  }
  if (onImageRendered !== undefined) {
    tmp.onImageRendered = Caml_option.valFromOption(onImageRendered);
  }
  return React.createElement(CategoryCard$Showside.make, tmp);
}
QuickViewCard.displayName = "QuickViewCard";
var make = QuickViewCard;
export { make };
/* react Not a pure module */